import { useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../constants/icons';
import { getWebPageVariant, WebPageType } from '../../../constants/webPageType';
import { SvgIcon } from '../SVGIcon';
import { TextButton, TextButtonSize } from '../TextButton';

import './ResetPasswordSuccessGroup.css';

type ResetPasswordSuccessGroupProps = {
  webPageType: WebPageType;
  email: string;
  phone: string;
  onClickLogin: () => void;
};

export const ResetPasswordSuccessGroup = (
  props: ResetPasswordSuccessGroupProps,
) => {
  const { webPageType, email, phone, onClickLogin } = props;
  const { t } = useTranslation();
  return (
    <div className="reset-password-success">
      <div className="centered-container">
        <section>
          <div className="text-content">
            <SvgIcon
              name={getWebPageVariant(webPageType).circleTick}
              width={128}
              height={128}
            />

            <p
              className={`reset-password-title ${
                getWebPageVariant(webPageType).classVariantLight2
              }`}
            >
              {t('You have reset your password.')}
            </p>
            <p>{t('Please try to login with your new password.')}</p>
            <div className="reset-password-row">
              <img className="item-icon" src={Icons[IconType.Email]} />
              <p>{email}</p>
            </div>
            <div className="reset-password-row">
              <img className="item-icon" src={Icons[IconType.Phone]} />
              <p>{phone}</p>
            </div>
            <TextButton
              text={t('OK')}
              size={TextButtonSize.Medium}
              variant={getWebPageVariant(webPageType).textButtonVariant}
              onClick={onClickLogin}
            />
          </div>
        </section>
      </div>
    </div>
  );
};
